module.exports = Object.freeze({
    version: "1.1.6"
});